import React from 'react';

const LoadingFallback = () => {
  return (
    <div className="h-[calc(100vh-250px)] flex flex-col items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm overflow-hidden p-8 space-y-6 text-center">
        {/* Animated spinner with better styling */}
        <div className="flex justify-center">
          <div className="relative">
            {/* Outer ring */}
            <div className="w-16 h-16 rounded-full border-4 border-gray-200"></div>
            {/* Animated arc */}
            <div className="absolute top-0 left-0 w-16 h-16 rounded-full border-4 border-transparent border-t-indigo-500 border-r-indigo-500 animate-spin"></div>
          </div>
        </div>
        
        {/* Loading text with subtle animation */}
        <h2 className="text-xl font-medium text-gray-800">
          <span className="inline-block animate-pulse">
            Loading
            <span className="inline-block ml-1">
              <span className="animate-bounce">.</span>
              <span className="animate-bounce delay-100">.</span>
              <span className="animate-bounce delay-200">.</span>
            </span>
          </span>
        </h2>
        
    
        
        {/* Subtle hint for users */}
        <p className="text-sm text-gray-500 mt-4">
          Please wait while we load your content
        </p>
      </div>
    </div>
  );
};

export default LoadingFallback;